import styled from 'styled-components/macro'
import { transparentize } from 'polished'

export const BalanceErrorWrap = styled.span`
  margin: 0 0 1.6rem;
  padding: 1rem 1.6rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  flex: 0 0 auto;
  font-weight: ${(props) => props.theme.font.weight.regular};
  font-size: 1.4rem;
  line-height: 1.5;
  border-radius: 0.8rem;
  justify-content: flex-start;
  color: ${(props) => props.theme.color.textHintSecond};
  color: ${(props) => props.theme.color.danger};
  background-color: ${(props) => transparentize(0.86, props.theme.color.danger)};
`

export const BalanceErrorTitle = styled.h4`
  margin: 0 0 1rem;
  font-weight: ${(props) => props.theme.font.weight.medium};
  font-size: 1.6rem;
  line-height: 1.47;
`

export const BalanceErrorText = styled.h4`
  margin: 0rem;
  font-weight: ${(props) => props.theme.font.weight.medium};
  font-size: 1.4rem;
  line-height: 1.47;
`
